/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createApplication = /* GraphQL */ `
  mutation CreateApplication(
    $input: CreateApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    createApplication(input: $input, condition: $condition) {
      id
      name
      plan
      date
      instance_count
      instances {
        launching_order
        instance_id
        delay
        provisioned_product_id {
          value
          label
          primary_az_id
          secondary_az_id
          hostname
        }
      }
      active_node
      account_id
      dr_status
      dr_state
      primary_az_id
      secondary_az_id
      tags
      createdAt
      updatedAt
      last_modified_by
    }
  }
`;
export const updateApplication = /* GraphQL */ `
  mutation UpdateApplication(
    $input: UpdateApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    updateApplication(input: $input, condition: $condition) {
      id
      name
      plan
      date
      instance_count
      instances {
        launching_order
        instance_id
        delay
        provisioned_product_id {
          value
          label
          primary_az_id
          secondary_az_id
          hostname
        }
      }
      active_node
      account_id
      dr_status
      instances_recovered
      dr_state
      primary_az_id
      secondary_az_id
      tags
      createdAt
      updatedAt
      last_modified_by
      deleted
    }
  }
`;
export const deleteApplication = /* GraphQL */ `
  mutation DeleteApplication(
    $input: DeleteApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    deleteApplication(input: $input, condition: $condition) {
      id
      name
      plan
      date
      instance_count
      instances {
        launching_order
        instance_id
        delay
        provisioned_product_id {
          value
          label
          primary_az_id
          secondary_az_id
          hostname
        }
      }
      active_node
      account_id
      dr_status
      instances_recovered
      dr_state
      primary_az_id
      secondary_az_id
      tags
      createdAt
      updatedAt
      last_modified_by
      deleted
    }
  }
`;
